import script from "./VisitorStatsWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./VisitorStatsWidget.vue?vue&type=script&setup=true&lang=ts"

import "./VisitorStatsWidget.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__